module.exports = __webpack_public_path__ + "static/pelne_wsparcie-01-0ae72c88e90f53c2eedd0d7176cd9061.png";